import { theme } from 'antd';
import type { CSSProperties, ReactNode } from 'react';
import React from 'react';

type FormSectionDividerProps = {
  title: ReactNode;
  style?: CSSProperties;
};

export function FormSectionDivider({ title, style }: FormSectionDividerProps) {
  const { token } = theme.useToken();

  const rootStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    margin: '8px 0 20px',
    ...style,
  } as const;

  const titleStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    color: token.colorTextHeading,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.4,
    letterSpacing: '0.02em',
    flex: '0 0 auto',
  } as const;

  const markerStyle = {
    width: 4,
    height: 16,
    borderRadius: 2,
    background: token.colorPrimary,
    flex: '0 0 auto',
  } as const;

  return (
    <div data-crm-form-section style={rootStyle}>
      <span style={titleStyle}>
        <span data-crm-form-marker aria-hidden style={markerStyle} />
        {title}
      </span>
    </div>
  );
}
